document.querySelectorAll('.hero__gallery').forEach((gallery) => {
    const swiperEl = gallery.querySelector('.hero__gallery-swiper');
    if (!swiperEl) return;

    new Swiper(swiperEl, {
        direction: 'vertical',
        loop: true,
        loopAdditionalSlides: 6,
        slidesPerView: 'auto',
        spaceBetween: 130,
        speed: 10000,
        allowTouchMove: false,
        autoplay: {
            delay: 1,
            disableOnInteraction: true,
        },
    });
});

// Desktop: the hero tickets pill sticks in place, then pins to the viewport
// once scrolled past its own position (persists to the end of the page).
// Mobile keeps the separate slide-down bar below instead (see isDesktop()).
const stickyPill = document.querySelector('.hero__tickets');
const isDesktop = () => window.matchMedia('(min-width: 768px)').matches;

if (stickyPill) {
    const placeholder = document.createElement('div');
    placeholder.style.display = 'none';
    stickyPill.parentNode.insertBefore(placeholder, stickyPill);

    const STICK_TOP = 16; // matches top: 1rem in SCSS
    let originalTop = null;

    const unpin = () => {
        stickyPill.classList.remove('is-pinned');
        stickyPill.style.left = '';
        placeholder.style.display = 'none';
    };

    const measure = () => {
        const wasPinned = stickyPill.classList.contains('is-pinned');
        if (wasPinned) unpin();
        const rect = stickyPill.getBoundingClientRect();
        originalTop = rect.top + window.scrollY;
        if (wasPinned) update();
    };

    const update = () => {
        if (!isDesktop()) {
            if (stickyPill.classList.contains('is-pinned')) unpin();
            return;
        }

        if (originalTop === null) measure();

        if (window.scrollY + STICK_TOP >= originalTop) {
            if (!stickyPill.classList.contains('is-pinned')) {
                const rect = stickyPill.getBoundingClientRect();
                placeholder.style.height = `${stickyPill.offsetHeight}px`;
                placeholder.style.marginBottom = getComputedStyle(stickyPill).marginBottom;
                placeholder.style.display = 'block';
                stickyPill.style.left = `${rect.left}px`;
                stickyPill.classList.add('is-pinned');
            }
        } else if (stickyPill.classList.contains('is-pinned')) {
            unpin();
        }
    };

    measure();
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', () => measure());
}

const heroMobileBar = document.getElementById('hero-mobile-bar');
const heroSection = document.querySelector('.hero');

if (heroMobileBar && heroSection && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
        ([entry]) => {
            const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            heroMobileBar.classList.toggle('is-visible', scrolledPast);
        },
        { threshold: 0 }
    );
    observer.observe(heroSection);
}
